import { ImageModuleBaseData } from './interfaces';

export function getIieSourceImageUrl(moduleData: ImageModuleBaseData) {
    return moduleData.transformedImageUrl ? moduleData.transformedImageUrl : moduleData.origImageUrl;
}

export function getIieSourceImageKey(moduleData: ImageModuleBaseData) {
    return moduleData.transformedImageUrl ? 'transformedImageUrl' : 'origImageUrl';
}

export function getIieSourceImageWidth(moduleData: ImageModuleBaseData) {
    return moduleData.transformedImageUrl ? moduleData.transformedImageWidth : moduleData.origImageWidth;
}

export function getIieSourceImageHeight(moduleData: ImageModuleBaseData) {
    return moduleData.transformedImageUrl ? moduleData.transformedImageHeight : moduleData.origImageHeight;
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/image/util.ts
 **/